import {EventBus, EventTypes} from '../../consts/const-event-types'

export default class Header {
  constructor(element) {
    this.el = element
    this.myHtml = document.querySelector("html")
    this.myBody = document.querySelector("body")
    this.toggle = this.el.querySelector(".menuToggle")
    this.slidemenu = this.el.querySelector(".navigationbox")
    this.menutext = this.el.querySelector(".menu")
    this.closeText = this.el.querySelector(".closeText")
    this.closeIcon = this.el.querySelector(".closeIcon")
    this.closeoverlay = this.el.querySelector(".click-close")
    this.navlink = document.querySelectorAll(".navlink")
    this.searchToggle = this.el.querySelector(".search-icon")
    this.searchOverlay = this.el.querySelector(".search-overlay")
    this.languageselect = this.el.querySelector(".language")
    this.searchclose = this.el.querySelector(".search-close-wrap")
    this.searchexplainer = this.el.querySelector(".explainer")
    this.searchInput = this.el.querySelector(".searchbar")
    this.searchList = this.el.querySelector(".search-suggestion-list")
    this.submitbutton = this.el.querySelector(".search-submit")
    this.searchlabel = this.el.querySelector(".searchLabel")
    this.searchanimate = this.searchanimate.bind(this)
    this.menuanimate = this.menuanimate.bind(this)
    this.removeMenu = this.removeMenu.bind(this)
    this.openMenu = this.openMenu.bind(this)
    this.removeSearch = this.removeSearch.bind(this)
    this.openSearch = this.openSearch.bind(this)
    this.searchFocus = this.searchFocus.bind(this)
    this.updateValue = this.updateValue.bind(this)
    this.createList = this.createList.bind(this)
    this.interactiveEvents = this.interactiveEvents.bind(this)
   
    
    this.init()
  }
  init() {

        
    EventBus.addEventListener(EventTypes.MY_CUSTOM_EVENT, event => {
      
    });   
    if (this.toggle) {
        
        this.toggle.addEventListener("click", event => {
          this.menuanimate()
        })

    }
    if (this.menutext) {
        
      this.menutext.addEventListener("click", event => {
        this.menuanimate()
      })

  }
    if (this.searchToggle) {
        
      this.searchToggle.addEventListener("click", event => {
        this.searchanimate()
      })  
  }
    
      this.closeoverlay.addEventListener("click", event => {
        
       
        this.menuanimate()
        
      })
      this.closeIcon.addEventListener("click", event => {
        
       
        this.menuanimate()
        
      })
     

      this.searchclose.addEventListener("click", event => {
        this.searchanimate()
      })
    
}
 
  menuanimate() {
    const links = document.querySelectorAll(".navlink");
    

    for (let i = 0; i < links.length; i++) {
      links[i].classList.remove("link-fadein");  
    }
    
    if (this.slidemenu.classList.contains("navigationslide")) {
      this.slidemenu.classList.remove("navigationslide")
      this.myBody.classList.remove("overflow")
      this.searchToggle.classList.remove("nodisplay")
      this.languageselect.classList.remove("nodisplay")
      this.closeoverlay.classList.remove("show-overlay")
      this.toggle.classList.remove("hide-menuopen")
      this.closeIcon.classList.remove("menuicon-slide")
      setTimeout(() => this.removeMenu(), 300);
      
      
      
    } else {
      this.slidemenu.style.display = "block"
      setTimeout(() => this.openMenu(), 200)
      
      this.myBody.classList.add("overflow")
      this.searchToggle.classList.add("nodisplay")
      this.languageselect.classList.add("nodisplay")
      this.closeoverlay.classList.add("show-overlay")
      this.toggle.classList.add("hide-menuopen")
      
      
      
     
      let i = 0;
      (function droplinks(i) {
        setTimeout(function(){
            
            if(i < links.length - 1)  droplinks(i+1)
            links[i].classList.add("link-fadein")
          }, 120);
      })(i)
    }
    
  }
  openMenu() {
    this.slidemenu.classList.add("navigationslide")
    this.closeIcon.classList.add("menuicon-slide")
  }
  removeMenu() {
    this.slidemenu.style.display = "none"
  }

  searchanimate() {
    if (this.searchOverlay.classList.contains("search-slidedown")) {
      this.searchOverlay.classList.remove("search-slidedown")
      this.myBody.classList.remove("overflow")
      this.myHtml.classList.remove("overflow")
      this.searchToggle.classList.remove("nodisplay")
      this.searchclose.classList.remove("search-close-slide")
      this.searchexplainer.classList.remove("explainer-slide")
      setTimeout(() => this.removeSearch(), 300)
    } else {
      this.searchOverlay.style.display = "block"
      setTimeout(() => this.openSearch(), 200)
      this.myBody.classList.add("overflow")
      this.myHtml.classList.add("overflow")
      this.searchToggle.classList.add("nodisplay")
      
      
      
    }
  }
  removeSearch() {
    this.searchOverlay.style.display = "none"
  }
  openSearch() {
    
    this.searchOverlay.classList.add("search-slidedown")
    this.searchclose.classList.add("search-close-slide")
    this.searchexplainer.classList.add("explainer-slide")
    setTimeout(() => this.searchFocus(), 500)
    
  }
  searchFocus () {
    this.searchInput.focus();
    this.searchInput.addEventListener('input', this.updateValue)
  }
  updateValue(e) {
    let searchParameter = e.target.value;
	let searchUrl = e.target.getAttribute("data-autocomplete-url");
    fetch(searchUrl + searchParameter)
    .then(res => res.json())
    .then(data => this.createList(data))

    
  }
  createList(data) {
    const suggestionList = `<div><ul>
    ${this.createListElements(data)}
    </ul></div>`
    this.searchList.innerHTML = suggestionList

    if(this.searchInput.value.length < 1) {
      this.searchList.style.display = "none"
      this.searchlabel.style.opacity = 1;
    } else if(this.searchInput.value.length > 1){
      this.searchList.style.display = "block"
      this.searchlabel.style.opacity = 0;
    }
    this.interactiveEvents()
  }
  createListElements(data) {
    const getlistItems = data.suggestions.map(item => {
      return`
      <li><a href="#">${item}</a></li>`
    }).join("")
    return getlistItems;
  }
  interactiveEvents() {
    const Items = this.searchList.querySelectorAll("li")
    const itemsArr = Array.from(Items);
    itemsArr.forEach( item => {
      item.addEventListener("click", event => {
        const itemValue = item.textContent;
        this.searchInput.value = itemValue;
        this.submitbutton.click();
      })
    })
  }
}